import { initialize, getABTProvider } from './statsig'
import { getUserCountryCode } from '@/utils/country-config'
import locator from '@/service-locator'

/**
 * Initialize Statsig with country detection
 * Handles both scenarios:
 * 1. Country detection completes before Statsig initialization
 * 2. Statsig initializes before country detection completes
 */
export const initializeStatsigWithCountry = async () => {
  const statsigKey =
    process.env.VUE_APP_STATSIG_CLIENT_KEY || locator.config.statsigKey

  if (!statsigKey) {
    console.warn('Statsig client key not found, skipping initialization')
    return
  }

  const defaultCountry = 'SA'
  let userCountry = defaultCountry

  // Base configuration
  const baseConfig = {
    sdkKey: statsigKey,
    user: {},
    sdkOptions: {
      environment: { tier: process.env.VUE_APP_STATSIG_CLIENT_ENV },
      country: userCountry,
    },
  }

  // Initialize Statsig immediately with default country
  await initialize(baseConfig.sdkKey, baseConfig.user, baseConfig.sdkOptions)

  // Start country detection in background and update when complete
  getUserCountryCode()
    .then((detectedCountry) => {
      userCountry = detectedCountry

      // Update Statsig with detected country
      const abtProvider = getABTProvider()
      return abtProvider.updateUser({
        ...baseConfig.user,
        country: userCountry,
      })
    })
    .catch((error) => {
      console.warn('Failed to get user country, keeping default:', error)
      // No need to update if we're keeping the default
    })
}
